<template>
  <modal-container
    v-if="modelValue"
    @close="closeModal"
    :iconColor="'#bd9478'"
    :icon="'mdi-cloud-download'"
    :gap="'30px'"
    :borderRadius="'20px'"
    :padding="'30px'"
    :paddingTop="'30px'"
    :title="$t('Models.InvoiceDebtRequestModel.title')"
  >
    <div class="model-content d-flex ga-4 flex-column">
      <div class="text-center d-flex flex-column">
        <span>{{ $t("Models.InvoiceDebtRequestModel.contentText") }}</span>
        <span class="font-weight-bold">{{ userEmail }}</span>
      </div>
      <BaseButton
        backgroundColor="#bd9478"
        paddingTop="8px"
        paddingBottom="8px"
        paddingLeft="10px"
        paddingRight="10px"
        @click="closeModal"
      >
        <span class="btn-text">{{ "אישור" }}</span>
      </BaseButton>
    </div>
  </modal-container>
</template>

<script>
import BaseButton from "../../UI/BaseButton.vue";
import modalContainer from "../../UI/modals/modal-container.vue";
export default {
  components: { modalContainer, BaseButton },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    userEmail: {
      type: String,
      default: "",
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:modelValue", false);
    },
  },
};
</script>

<style scoped lang="scss">
.model-content {
  font-size: $mediumTextSize;
}
</style>
